import { render, staticRenderFns } from "./FlatAds.vue?vue&type=template&id=4a3c41f7"
import script from "./FlatAds.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlatAds.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports